import { createContext, useContext, useState, useEffect } from 'react'
import { callContract } from '../contractClient'
import { contracts as meContracts } from '../../../../shared/features/me.contracts'
import { setGlobalTimezone } from '../utils/formatters'

const DEFAULT_TZ = 'Europe/Copenhagen'
const TimezoneContext = createContext(DEFAULT_TZ)

export function TimezoneProvider({ children }) {
  const [timezone, setTimezone] = useState(DEFAULT_TZ)

  useEffect(() => {
    callContract(meContracts.usersMe)
      .then(res => {
        const tz = res.data?.user?.timezone || DEFAULT_TZ
        setTimezone(tz)
        setGlobalTimezone(tz)
      })
      .catch(() => {
        setGlobalTimezone(DEFAULT_TZ)
      })
  }, [])

  return (
    <TimezoneContext.Provider value={timezone}>
      {children}
    </TimezoneContext.Provider>
  )
}

export function useTimezone() {
  return useContext(TimezoneContext)
}
